import { render, staticRenderFns } from "./UM_terminalCount.vue?vue&type=template&id=47be64e9&scoped=true&"
import script from "./UM_terminalCount.vue?vue&type=script&lang=js&"
export * from "./UM_terminalCount.vue?vue&type=script&lang=js&"
import style0 from "./UM_terminalCount.vue?vue&type=style&index=0&id=47be64e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be64e9",
  null
  
)

export default component.exports